import React, {useContext, useState} from "react";
import moment from "moment";
import ReactQuill from 'react-quill';
import FormSheet from "../../../overbox/sheet/FormSheet";
import LoaderCircle from "../../../tools/loader/LoaderCircle";
import StoreController from "../../../../stories/_client/Stores/StoreController";
import AppContext from "../../../../context/AppContext";
import "../../../../css/page/contents/client/ClientInformations.css";
import "moment/locale/fr";
import "react-quill/dist/quill.snow.css";

const ClientJournal = props => {
    moment.locale("fr");
    const { inDatas } = props;
    const { setEvent, setGetDatasPopup } = useContext(AppContext);
    const [ datas, setDatas ] = useState(inDatas);
    const [ innerObjectType, setInnerObjectType ] = useState(null);
    const [ innerDatas , setInnerDatas ] = useState(null);
    const [ entryHistory, setEntryHistory ] = useState("");
    const [ savingHistory, setSavingHistory ] = useState(false);

    const getStore = () => {
        const controller = new StoreController();
        controller._callback = returnGetStore;
        controller.show(datas.store.id);
    }
    const returnGetStore = (object, error, status) => {
        switch (status) {
            case 200:
                let datasTmp = Object.assign({}, datas);
                datasTmp.store = object;
                setDatas(datasTmp);
                setGetDatasPopup(prev => ({
                    ...prev,
                    store: object
                }));

                break;
            default:
                break;
        }
    }
    const stateInnerPopup = () => {
        return innerObjectType !== null
    }
    const stateInnerForm = () => {
        switch (innerObjectType) {
            default: break;
        }

        return false;
    }
    const titleFormSheet = () => {
        switch (innerObjectType) {
            case "assignUser":
                return "Choisir un utilisateur";
            case "newLegalData":
                return "Informations juridiques";
            case "newContact":
                return "Nouveau contact";
            case "newAddress":
                return "Nouvelle adresse";
            case "updateContact":
                return "Modifier le contact";
            case "updateAddress":
                return "Modifier l'adresse";
            default:
                return "";
        }
    }
    const closeInnerForm = () => {
        setInnerObjectType(null);
        setInnerDatas(null);
    }
    const returnInnerForm = () => {
        closeInnerForm();
        getStore();
    }
    const inputEntry = event => {
        setEntryHistory(event.currentTarget.value);
    }
    const saveHistory = () => {
        if (entryHistory.length === 0 || savingHistory)
            return;

        setSavingHistory(true);

        const controller = new StoreController();
        controller._callback = returnSaveHistory;
        controller.postHistory(datas.store, { comment: entryHistory });
    }
    const returnSaveHistory = (response, error, status) => {
        setSavingHistory(false);

        switch (status) {
            case 204:
                setEvent({
					type: "valid",
					text: "Commentaire enregistré"
				});
                setEntryHistory("");
                getStore();
                break;
			default:
                setEvent({
					type: "error",
					text: "Une erreur s'est produite lors de l'enregistrement"
				});

                break;
        }
    }

    return (<>
        <div className={"overlay" + (stateInnerPopup() ? " appear" : "")}>
                <div className={"wrapPopup"}>
                    <div className={"popup " + (stateInnerForm() ? "new" : "loading")}>
                        {
                            stateInnerForm()
                                ? <FormSheet
                                    objectType={ innerObjectType }
                                    datas={ innerDatas }
                                    parentDatas={ datas }
                                    title={ titleFormSheet() }
                                    callbackClose={ closeInnerForm }
                                    callbackSuccess={ returnInnerForm } />
                                : <div className={"containerLoading"}>
                                    <LoaderCircle display="loader inPopup" hide="" strokeWidth="10" stroke="#00000070" />
                                </div>
                        }
                    </div>
                </div>
            </div>
        <div className={"containerInformations"}>
            <div className={"wrapInformations"}>
                <div className={"wrapHistory"}>
                    <div className={"history"}>
                        {
                            datas.store.histories.map((history, index) => (
                                <div key={index} className={"item"}>
                                    <p className={"creator"}>Par <b>{ history.creator_name }</b></p>
                                    <p className={"date"}>le <b>{ moment(history.created_at).format("DD/MM/YYYY HH:mm") }</b>, il y a { moment(history.created_at).fromNow(true) }</p>
                                    <ReactQuill className={"comment"} value={history.comment} readOnly={true} theme={"bubble"} />
                                </div>
                            ))
                        }
                        {
                            datas.store.histories.length === 0
                            && <div className={"item"}>
                                <p className={"creator"}>Aucun élément dans le journal</p>
                            </div>
                        }
                    </div>
                    <div className={"input"}>
                        <ReactQuill id={"richInput"} className={"richInput"} theme={"snow"} placeholder={"Inscrire une note..."} value={entryHistory} onChange={setEntryHistory} />
                        <button onClick={saveHistory}>
                            {
                                savingHistory
                                    ? <LoaderCircle display="loader" hide="" strokeWidth="10" stroke="#2D2D2D" />
                                    : "Enregistrer"
                            }
                        </button>
                        <div className={"clearing"} />
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default ClientJournal;